/**
 * Приводит число к строке заданного размера путем добавления нулей перед числом.
 * @example
 * pad(9, 2) // '09'
 * pad(3, 4) // '0003'
 * // Не изменяет число, если его длина превышает или равна желаемой
 * pad(12, 2) // '12'
 * pad(145, 2) // '145'
 */
export const padNumber = (value: number, desiredLength: number): string => {
    if (isNaN(value)) throw new Error('Recieved \'NaN\' as value');

    const valueAsString = String(value);
    const lengthDifference = valueAsString.length - desiredLength;

    return lengthDifference <= 0 ? '0'.repeat(Math.abs(lengthDifference)).concat(valueAsString) : valueAsString;
};
